// extracted by mini-css-extract-plugin
export var button = "q2x60";
export var cancelButton = "xmCh7";
export var focusWithin = "g58Ug";
export var hide = "RVRqX";
export var searchContainer = "SZv4f";
export var textarea = "m7uG6";
export var wide = "kPLef";